export const glUtil = {
  createVertexShader(gl, vertexSource) {
    const vertexShader = gl.createShader(gl.VERTEX_SHADER)
    gl.shaderSource(vertexShader, vertexSource)
    gl.compileShader(vertexShader)
    const success = gl.getShaderParameter(vertexShader, gl.COMPILE_STATUS)
    if (!success) {
      throw 'could not compile shader:' + gl.getShaderInfoLog(vertexShader)
    }

    return vertexShader
  },

  createFragmentShader(gl, fragmentSource) {
    const fragmentShader = gl.createShader(gl.FRAGMENT_SHADER)
    gl.shaderSource(fragmentShader, fragmentSource)
    gl.compileShader(fragmentShader)
    const success = gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS)
    if (!success) {
      throw 'could not compile shader:' + gl.getShaderInfoLog(fragmentShader)
    }

    return fragmentShader
  },

  // createVertexShaderFromPath (gl, path) {
  //   return fetch(path)
  //     .then(response => response.text())
  //     .then(source => glUtil.createVertexShader(gl, source))
  // },

  // createFragmentShaderFromPath (gl, path) {
  //   return fetch(path)
  //     .then(response => response.text())
  //     .then(source => glUtil.createFragmentShader(gl, source))
  // },

  // @@@
  createProgram(gl, vertexShader, fragmentShader, feedbackVaryings) {
    const program = gl.createProgram()
    gl.attachShader(program, vertexShader)
    gl.attachShader(program, fragmentShader)
    if (feedbackVaryings) gl.transformFeedbackVaryings(program, feedbackVaryings, gl.SEPARATE_ATTRIBS)
    gl.linkProgram(program)

    const success = gl.getProgramParameter(program, gl.LINK_STATUS)
    if (!success) {
      throw 'could not link program:' + gl.getProgramInfoLog (program)
    }

    const wrapper = { program }

    const numAttributes = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES)
    for (let i = 0; i < numAttributes; i++) {
      const attribute = gl.getActiveAttrib(program, i)
      wrapper[attribute.name] = gl.getAttribLocation(program, attribute.name)
    }
    const numUniforms = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS)
    for (let i = 0; i < numUniforms; i++) {
      const uniform = gl.getActiveUniform(program, i)
      wrapper[uniform.name] = gl.getUniformLocation(program, uniform.name)
    }

    return wrapper
  },

  /**
   * TransformFeedback 用のプログラムを作成する
   * @param {WebGLRenderContext|WebGL2RenderingContext} gl
   * @param {String} vertexShader
   * @param {String} fragmentShader
   * @param {Array.<String>} feedbackVaryings
   * @returns
   */
  createProgramFeedback(gl, vertexShader, fragmentShader, feedbackVaryings) {
    return this.createProgram(gl, vertexShader, fragmentShader, feedbackVaryings)
  },

  // @@@
  bindAttribute(gl, buffer, attribute, numComponents) {
    gl.bindBuffer(gl.ARRAY_BUFFER, buffer)
    gl.enableVertexAttribArray(attribute)
    gl.vertexAttribPointer(attribute, numComponents, gl.FLOAT, false, 0, 0)
  },

  /**
   * インスタンシング用の頂点情報を設定する関数
   * @param {WebGLRenderContext|WebGL2RenderingContext} gl
   * @param {WebGLExtensionANGLE_instanced_arrays} ext
   * @param {WebGLBuffer} vbo
   * @param {Number} location
   * @param {Number} stride
   * @param {Number} divisor
   */
  bindAttributeInstancedArray(gl, ext, vbo, location, stride, divisor = 1) {
    gl.bindBuffer(gl.ARRAY_BUFFER, vbo)
    gl.enableVertexAttribArray(location)
    gl.vertexAttribPointer(location, stride, gl.FLOAT, false, 0, 0)

    if (gl instanceof WebGL2RenderingContext) {
      gl.vertexAttribDivisor(location, divisor)
    } else {
      ext.vertexAttribDivisorANGLE(location, divisor)
    }
  },

  // @@@
  bindTexture(gl, texture, unit) {
    gl.activeTexture(gl.TEXTURE0 + unit)
    gl.bindTexture(gl.TEXTURE_2D, texture)
  },

  // @@@
  bindFramebuffer(gl, framebuffer, texture) {
    gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer)
    if (texture) {
      gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0)
    }
  },

  /**
   *
   * @param {WebGLRenderContext|WebGL2RenderingContext} gl
   * @param {Array} data
   * @param {Number} length
   * @param {Number} usage  enum gl.STATIC_DRAW, gl.DYNAMIC_COPY, gl.STREAM_DRAW
   * @returns
   */
  createVBO(gl, data, length, usage = gl.STATIC_DRAW) {
    const vbo = gl.createBuffer()
    gl.bindBuffer(gl.ARRAY_BUFFER, vbo)
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(data), usage)
    gl.bindBuffer(gl.ARRAY_BUFFER, null)

    return { buffer: vbo, length }
  },

  createVBOFeedback(gl, data, length) {
    return glUtil.createVBO(gl, data, length, gl.DYNAMIC_COPY)
  },

  createIBO(gl, data, length) {
    const ibo = gl.createBuffer()
    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, ibo)
    gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, new Int16Array(data), gl.STATIC_DRAW)
    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null)

    return { buffer: ibo, length }
  },

  createTexture(gl, data, width, height, filter) {
    console.log({ filter })
    if (filter === undefined) filter = gl.NEAREST
    const texture = gl.createTexture()
    gl.bindTexture(gl.TEXTURE_2D, texture)
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE)
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE)
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, filter)
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, filter)
    if (data instanceof Uint8Array) {
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, width, height, 0, gl.RGBA, gl.UNSIGNED_BYTE, data)
    } else {
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, data)
    }
    gl.bindTexture(gl.TEXTURE_2D, null)
    return texture
  },

  createFloatTexture(gl, data, width, height) {
    // テクスチャオブジェクトの生成
    const tex = gl.createTexture()

    // テクスチャをバインドする
    gl.bindTexture(gl.TEXTURE_2D, tex)
    if (gl instanceof WebGL2RenderingContext) {
      // テクスチャへイメージを適用
      let internalFormat = gl.RGBA32F
      let format = gl.RGBA
      if (width * height === data.length) {
        internalFormat = gl.R32F
        format = gl.RED
      } else if (width * height * 2 === data.length) {
        internalFormat = gl.RG32F
        format = gl.RG
      }
      gl.texImage2D(gl.TEXTURE_2D, 0, internalFormat, width, height, 0, format, gl.FLOAT, new Float32Array(data)) // webgl2 https://registry.khronos.org/webgl/specs/latest/2.0/#TEXTURE_TYPES_FORMATS_FROM_DOM_ELEMENTS_TABLE
    } else {
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, width, height, 0, gl.RGBA, gl.FLOAT, new Float32Array(data)) // webgl2 https://registry.khronos.org/webgl/specs/latest/2.0/#TEXTURE_TYPES_FORMATS_FROM_DOM_ELEMENTS_TABLE
    }

    // どんなサイズの画像でもレンダリングできるようにパラメータを設定する
    // https://webglfundamentals.org/webgl/lessons/ja/webgl-image-processing.html
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE) // 横座標の値を 0 ～ 1 の範囲内に収まるようクランプ
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE) // 縦座標の値を 0 ～ 1 の範囲内に収まるようクランプ
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST) // 縮小処理時の補間方法
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST) // 拡大処理時の補間方法

    // // ミップマップを生成 今回は作成しない
    // gl.generateMipmap(gl.TEXTURE_2D);

    // テクスチャのバインドを無効化
    gl.bindTexture(gl.TEXTURE_2D, null)

    return tex
  },

  /**
   * @param {*} gl
   * @param {*} width
   * @param {*} height
   */
  createFloatFramebuffer(gl, width, height) {
    const framebuffer = gl.createFramebuffer()
    gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer)

    const texture = gl.createTexture()
    gl.bindTexture(gl.TEXTURE_2D, texture)
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA16F, width, height, 0, gl.RGBA, gl.FLOAT, null)

    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR)
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR)
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE)
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE)

    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0)

    gl.bindTexture(gl.TEXTURE_2D, null)
    gl.bindFramebuffer(gl.FRAMEBUFFER, null)

    return { framebuffer, texture }
  }

}
